
import React, { useState } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

import { URLDevelopment } from "../helpers/URL";
import Button from "../components/buttons/button.component";
import Container from "../components/container/container.component";
import FormInput from "../components/inputs/form.input.component";

const Register = ({ isLoading }) => {
  const history = useHistory();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const {
    name,
    email,
    password,
    confirmPassword,
  } = formData;

  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Required fields
    if (!name || !email || !password || !confirmPassword) {
      return toast.error("All fields are required");
    }

    // Email format
    if (!/\S+@\S+\.\S+/.test(email)) {
      return toast.error("Invalid email format");
    }

    // Password confirmation
    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      console.log("📤 REGISTER REQUEST:", {
        name,
        email,
      });

      const res = await axios.post(
        `${URLDevelopment}/api/user/register`,
        {
          name,
          email,
          password,
        }
      );

      console.log("📥 REGISTER RESPONSE:", res.data);
      console.log("📥 STATUS:", res.status);

      // OTP successfully sent
      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data?.message === "OTP sent"
      ) {
        toast.success("OTP sent successfully");

        history.push("/verify-otp", {
          email: res.data.email || email,
        });

        return;
      }

      // Backend returned another successful response
      if (res.status >= 200 && res.status < 300) {
        toast.success(res.data?.message || "OTP sent");

        history.push("/verify-otp", {
          email: res.data?.email || email,
        });

        return;
      }

      toast.error(
        res.data?.message || "Registration failed"
      );

    } catch (err) {
      console.error("❌ REGISTER ERROR:", err);

      console.error(
        "❌ RESPONSE:",
        err.response?.data
      );

      const msg =
        err.response?.data?.message ||
        "Unable to register or send OTP";

      toast.error(msg);
    }
  };

  return (
    <Container>
      <form
        onSubmit={onSubmit}
        className="bg-white rounded-xl shadow-2xl p-6 my-16 w-full max-w-md mx-auto flex flex-col space-y-4"
      >
        <h2 className="font-bold text-3xl text-center">
          Create Account
        </h2>

        <FormInput
          title="Name"
          placeholder="John Doe"
          value={name}
          handleChange={handleChange("name")}
          type="text"
        />

        <FormInput
          title="Email"
          placeholder="john@example.com"
          value={email}
          handleChange={handleChange("email")}
          type="email"
        />

        <FormInput
          title="Password"
          placeholder="******"
          value={password}
          handleChange={handleChange("password")}
          type="password"
        />

        <FormInput
          title="Confirm Password"
          placeholder="******"
          value={confirmPassword}
          handleChange={handleChange("confirmPassword")}
          type="password"
        />

        {isLoading && (
          <div
            id="loading"
            className="self-center"
          />
        )}

        {!isLoading && (
          <Button
            title="Register & Send OTP"
            type="submit"
            moreStyle="w-full py-3 text-lg"
          />
        )}

        <div className="text-center pt-2">
          <span className="text-gray-600 text-sm">
            Already have an account?{" "}

            <Link
              to="/login"
              className="text-blue-600 font-semibold hover:underline"
            >
              Login
            </Link>
          </span>
        </div>
      </form>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.auth.loading,
});

export default connect(mapStateToProps)(Register);

